var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.2 2.5v7.2a1.8 1.8 0 0 1-1.8 1.8H8.9l-4.5 3.6v-3.6H2.6A1.8 1.8 0 0 1 .8 9.7V2.5A1.8 1.8 0 0 1 2.6.7h10.8a1.8 1.8 0 0 1 1.8 1.8zM5.3 5.2H3.5V7h1.8zm1.8 0h1.8V7H7.1zm5.4 0h-1.8V7h1.8z",
    fill: "#4318ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.52c0c80e4d60b94d8abea940f127c7d2.svg";
export { ForwardRef as ReactComponent };